<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title fw-bold">Edit URL</h5>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  </div>

  <div class="modal-body">
    <div class="input-group">
      <span class="input-group-text"><i class="bi bi-link"></i></span>
      <textarea class="form-control" [(ngModel)]="url" (change)="parseUrl()"></textarea>
    </div>

    <div class="mt-3 d-flex justify-content-end">
      <app-input-switch [(ngModel)]="autoAddLeadUpParams">Auto-Add LeadUp Params</app-input-switch>
    </div>

    <form [formGroup]="formAdd" (ngSubmit)="add()" class="mt-2">
      <label class="form-label">Add new parameter</label>
      <div class="row">
        <div class="col-4">
          <input type="text" class="form-control" formControlName="key" placeholder="key">
        </div>
        <div class="col-auto">
          <div class="btn-group">
            <button type="button" class="btn btn-outline-primary dropdown-toggle" data-bs-toggle="dropdown"
                    aria-expanded="false">
              Tags
            </button>
            <ul class="dropdown-menu">
              @for (variable of variables; track variable) {
                <li class="dropdown-item dropdown-item-variables d-flex justify-content-between">
                  <span>{{ variable }}</span>
                  <span>
                  <button type="button" class="btn-primary ms-2 btn btn-sm" (click)="addVariable(variable)">
                    <i class="bi bi-plus-circle"></i> Normal</button>
                  <button type="button" class="btn-success ms-2 btn btn-sm" (click)="addEncryptedVariable(variable)">
                    <i class="bi bi-plus-circle"></i> Encrypted</button>
                  </span>
                </li>
              }
            </ul>
          </div>
        </div>
        <div class="col-5">
          <input type="text" class="form-control" formControlName="value" placeholder="value">
        </div>
        <div class="col-auto">
          <button type="submit" class="btn btn-primary">Add parameter</button>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 d-flex justify-content-end">
          <button type="button" class="btn btn-success" (click)="addAllParameters()">
            <i class="bi bi-magic"></i>
            Add all parameters
          </button>
        </div>
      </div>
    </form>

    <div class="table-responsive mt-5">
      <table class="table table-striped table-hover">
        <thead>
        <th>Key</th>
        <th>Value</th>
        <th></th>
        </thead>
        <tbody>
          @for (param of params; track param[0]) {
            <tr>
              <td>{{ param[0] }}</td>
              <td><input type="text" class="form-control" [ngModel]="param[1]"
                         (ngModelChange)="setParam(param[0], $event)"></td>
              <td>
                <button type="button" class="btn btn-sm text-danger" (click)="remove(param)"><i
                  class="bi bi-trash"></i></button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>
    <button type="submit" class="btn btn-primary fw-bold" (click)="update()">OK</button>
  </div>
</div>
